import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";

const FinalBilling = ({ patient }) => {
  const billing = patient.billing || {
    items: [],
    total: 0,
    paid: 0,
    due: 0,
  };

  const COLORS = ["#34D399", "#F87171"]; // Green for Paid, Red for Due
  const chartData = [
    { name: "Paid", value: billing.paid },
    { name: "Due", value: billing.due },
  ];

  return (
    <div className="p-6 bg-white shadow rounded-lg">
      <h2 className="text-lg font-bold mb-6 text-gray-800">Final Billing</h2>
      <div className="flex flex-col lg:flex-row items-center lg:items-start lg:space-x-8">
        {/* Pie Chart Section */}
        <div className="w-full lg:w-1/2 h-64">
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Billing Table Section */}
        <div className="w-full lg:w-1/2">
          <table className="w-full text-sm border-collapse border border-gray-300 mt-6 lg:mt-0">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border text-gray-700 font-semibold">
                  Description
                </th>
                <th className="px-4 py-2 border text-gray-700 font-semibold">
                  Amount
                </th>
                <th className="px-4 py-2 border text-gray-700 font-semibold">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {billing.items.length > 0 ? (
                billing.items.map((item, index) => (
                  <tr key={index}>
                    <td className="border px-4 py-2 text-gray-600">
                      {item.description}
                    </td>
                    <td className="border px-4 py-2 text-gray-600">
                      ₹{item.amount.toLocaleString()}
                    </td>
                    <td className="border px-4 py-2">
                      {item.paid ? (
                        <span className="text-green-500 font-medium">Paid</span>
                      ) : (
                        <span className="text-red-500 font-medium">Due</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    className="text-center text-gray-500 py-4 font-medium"
                  >
                    No billing items available.
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot className="bg-gray-100">
              <tr>
                <td className="border px-4 py-2 font-semibold">Total</td>
                <td className="border px-4 py-2 font-semibold">
                  ₹{billing.total.toLocaleString()}
                </td>
                <td className="border px-4 py-2 font-semibold">
                  {billing.due > 0 ? (
                    <span className="text-red-500">Due</span>
                  ) : (
                    <span className="text-green-500">Paid</span>
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FinalBilling;
